export default __webpack_public_path__ + "static/media/Rami.538847b4.png";